import React, { useEffect, useState } from "react";
import { fetchClicks, exportClicksCsvUrl, getAdminToken } from "../../lib/adminApi";
import { Download, Loader2 } from "lucide-react";
import { Button } from "../../components/ui/button";

export default function AdminClicksPage() {
  const [clicks, setClicks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClicks(500)
      .then((d) => setClicks(d.clicks || []))
      .finally(() => setLoading(false));
  }, []);

  const downloadCsv = async () => {
    const res = await fetch(exportClicksCsvUrl(), {
      headers: { Authorization: `Bearer ${getAdminToken()}` },
    });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "clics-autopiecemalin.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-clicks-page" className="space-y-5">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-extrabold text-slate-50 sm:text-3xl">
            Clics bruts
          </h1>
          <p className="mt-1 text-sm text-slate-400">
            500 derniers clics sortants enregistrés. Export CSV pour recouper avec
            tes plateformes d'affiliation.
          </p>
        </div>
        <Button
          data-testid="export-clicks-csv"
          onClick={downloadCsv}
          className="gap-2 bg-cyan-500 text-slate-950 hover:bg-cyan-400"
        >
          <Download className="h-4 w-4" />
          Export CSV
        </Button>
      </header>

      <div className="surface-card overflow-x-auto rounded-2xl">
        {loading ? (
          <div className="flex items-center justify-center py-20 text-slate-400">
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            Chargement...
          </div>
        ) : (
          <table className="min-w-full text-sm">
            <thead className="border-b border-slate-800 bg-slate-900/60 text-left">
              <tr>
                <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-slate-400">Date</th>
                <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-slate-400">Fournisseur</th>
                <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-slate-400">Pièce</th>
                <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-slate-400">Véhicule</th>
                <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-slate-400">Plaque</th>
              </tr>
            </thead>
            <tbody>
              {clicks.map((c, i) => (
                <tr key={i} className="border-b border-slate-800/50 hover:bg-slate-900/40">
                  <td className="px-4 py-3 font-mono text-[11px] text-slate-400">
                    {new Date(c.created_at).toLocaleString("fr-FR")}
                  </td>
                  <td className="px-4 py-3 font-semibold text-slate-100">{c.supplier_id}</td>
                  <td className="px-4 py-3 text-slate-300">{c.part_query}</td>
                  <td className="px-4 py-3 text-slate-400">
                    {c.marque} {c.modele}
                  </td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-400">{c.plaque || "—"}</td>
                </tr>
              ))}
              {clicks.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-4 py-10 text-center text-slate-500">
                    Aucun clic enregistré pour le moment.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
